import Text from "@jnctn/design-system/Text/Text.component";
import useDocumentTitle from "@jnctn/hooks/useDocumentTitle";
import buildDocumentTitle from "@jnctn/webcore/ui-helpers/buildDocumentTitle";
import FlexLayoutItem, {
  layouts,
} from "@jnctn/design-system/Flexbox/FlexLayoutItem.component";
import { useBack } from "@jnctn-app/contexts/BackContext";
import { useAuthContext } from "../../contexts/AuthContextProvider";
import StandardButton from "@jnctn/design-system/Button/StandardButton.component";
import { ReactComponent as LogoutIcon } from "@jnctn/icons/logout.svg";
import Button from "@jnctn/design-system/Button/Button.component";
import { ReactComponent as ReportIssueIcon } from "@jnctn/icons/report-issue.svg";
import LinkAnchorButton from "@jnctn/design-system/Button/LinkAnchorButton.component";
import TenantPicker from "../../core/components/TenantPicker.component";

export function IncompleteProfileErrorPage({
  defaultTenant,
}: {
  defaultTenant?: string;
}) {
  useDocumentTitle(buildDocumentTitle(["JNCTN", "Incomplete profile"]));
  useBack(undefined);
  const { onSignOut } = useAuthContext();

  return (
    <FlexLayoutItem grow={1} layout={layouts.verticalStretch} className="p-10">
      <FlexLayoutItem
        grow={1}
        align="center"
        layout={layouts.verticalCenterAll}
        className="space-y-6 max-w-lg"
      >
        <Text size="header1" color="primary" textAlign="center">
          Your profile is incomplete.
        </Text>
        <Text size="body1" color="primary" textAlign="center">
          Your profile needs to be completed to access this action. You can
          choose to complete your profile below or log out and come back to it
          later.
        </Text>
        <TenantPicker
          label="Change to another tenant"
          defaultTenant={defaultTenant}
        />
        <LinkAnchorButton
          label="Complete profile"
          href={import.meta.env.REACT_APP_PORTAL_LOGIN_URL}
        />
        <StandardButton
          label="Sign Out"
          icon={<LogoutIcon />}
          onClick={onSignOut}
        />
      </FlexLayoutItem>
      <FlexLayoutItem align="center">
        <a
          href="https://help.jnctn.nz/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          className="flex"
        >
          <Button
            label="Report an Issue"
            icon={<ReportIssueIcon className="mr-4 w-8 h-8" />}
            className="justify-start inline-flex items-center font-semibold font-body text-charcoal-800"
          />
        </a>
      </FlexLayoutItem>
    </FlexLayoutItem>
  );
}
